var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgJobIcon = function SvgJobIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.568 7.507c.652 0 .964.322 1.008 1.002l.095 1.95H5.553c.03-.382.245-2.873.338-3.9.119-.907.48-1.02 1.55-1.02h4.686c1.353 0 1.364 0 2.195.897.998 1.071 1.17 1.071 2.452 1.07h8.794Zm-20.17 4.55h21.415c.812 0 1.143.431 1.089 1.12l-.744 11.396c-.063.695-.465 1.26-1.299 1.26H6.414c-.837 0-1.243-.572-1.298-1.26l-.8-11.254c-.061-.696.194-1.261 1.083-1.261Z",
    fill: "#FCFAF8"
  })));
};

export default SvgJobIcon;